import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';
import { media } from 'src/theme/breakpoints';

const TourOrEventCardStyle = styled('div')`
    &.card {
        position: relative;
        background-color: var(--sand-100);
        border-color: var(--sand-100);
    }

    &&.card {
        .itinerary-title-card {
            ${typography.bodyXl}
            margin-bottom: 0;
        }
    }

    &.edit {
        border: 2px solid var(--orange-300);
    }

    .iconAddComment {
        position: absolute;
        right: 0;
        top: 50%;
        margin-right: -25px;
        margin-top: -25px;
        cursor: pointer;
        transition: all 0.2s;
        z-index: 1;
        &:hover {
            transform: scale(1.1);
        }
    }
    .description {
        .tour-comment {
            ${typography.bodyMd}
            margin-top: 16px;
            li + li {
                padding-top: 5px;
            }
        }
    }

    ${media.mobile} {
        &&.card {
            padding: 24px;
        }
    }
`;

export default TourOrEventCardStyle;
